import React from 'react'
import AcquireWebComponent from '../../framework/MaterialUI'
import { Row, Col, FullRow } from '../../framework/Grid/'
import ActionInfo from 'material-ui/svg-icons/action/info-outline'
import Tooltip from 'rc-tooltip'
import 'rc-tooltip/assets/bootstrap_white.css';
import { text_definition } from '../../../utils/utility';

class CustomTagVariables extends AcquireWebComponent {
	getTypeTitle(){
		const {varType} = this.props
		switch(varType){
			default:
				return (<div></div>);
			case "page":
				return(
					<div className="input-group" >
					<span>{"Page Reference"}</span>
					<span className="input-group-addon no-padding-left">
						<Tooltip placement="right"
							overlayClassName="overlay-bg-yellow"
							overlay={text_definition("custom_variable_tip")}
							arrowContent={<div className="rc-tooltip-arrow-inner"></div>}>
							<ActionInfo style={{height:'20px', widht:'20px', marginTop:'-10px'}} />
						</Tooltip>
					</span>
					</div>
				)
			case "passthrough":
				return(
					<div className="input-group" >
						<span>{"Pass Through"}</span>
						<span className="input-group-addon no-padding-left">
							<Tooltip placement="right"
								overlayClassName="overlay-bg-yellow"
								overlay={text_definition("passthrough_variable_tip")}
								arrowContent={<div className="rc-tooltip-arrow-inner"></div>}>
								<ActionInfo style={{height:'20px', widht:'20px', marginTop:'-10px'}} />
							</Tooltip>
						</span>
					</div>
				)
		}
	}
	render(){
		const {varType, variables, addVariable, removeVariable, varChanged} = this.props
		return (
			<FullRow className="black-border p-10 no-margin-left no-margin-right mb-20">
				<Row className="pl-10 pt-10 no-padding-top no-padding-bottom no-padding-right">
					<Col xs="5" md="5" sm="5" lg="5" className="no-padding-left no-padding-right">
						<strong>Variable Type</strong>
					</Col>
					<Col xs="4" md="4" sm="4" lg="4" className="no-padding-left">
						{this.getTypeTitle()}
					</Col>
				</Row>
				{
					variables.map((item, index)=>{
						return(
							<Row key={'cvar-' + index} className="pl-10 no-padding-top pb-10 no-padding-right">
								<Col xs="5" md="5" sm="5" lg="5" className="no-padding-left no-padding-right pt-5">
									<strong>{varType === "page" ? "Reference Name" : "Pass Through Name"} {index + 1}</strong>
								</Col>
								<Col xs="6" md="6" sm="6" lg="6" className="no-padding-left no-padding-right">
									<input type="text" value={item} maxLength={36} onChange={(e)=>{varChanged(e, index)}}
									style={{border: 'solid 1px #000', width:'100%', lineHeight:'28px', paddingLeft:'5px'}} />
								</Col>
								<Col xs="1" md="1" sm="1" lg="1" className="no-padding-left text-right" 
									style={{display: index === variables.length - 1 ? 'block' : 'none'}}>
									<a onClick={(e)=>{e.preventDefault();removeVariable()}}><i className="icon-cancel-circle2" style={{color:"red"}}></i></a>
								</Col>					
							</Row>
						)
					})
				}
				<FullRow className="text-right no-padding-top no-padding-right no-padding-bottom">
					<button type="button" className="btn btn-default legitRipple btn-aa-default "
						onClick={(e)=> {e.preventDefault();addVariable()}}> Add Reference Name
					</button>
				</FullRow>
			</FullRow>
		)

	}
}

export default CustomTagVariables


// WEBPACK FOOTER //
// ./src/components/Insights/tags/CustomTagVariables.jsx